enum CreatePayeeType {
    ExistingPayee = "EXISTING_PAYEE",
    NewPayee = "NEW_PAYEE"
}
export default CreatePayeeType